import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import { RadioButton } from 'material-ui/RadioButton'
import UncheckedRadioButton from 'material-ui/svg-icons/toggle/radio-button-unchecked'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import images from '../../config/images'
import { HelpText, RadioText } from './styles'
import config from '../../config/config'
import { isSentry, parseQuery } from '../../lib'
import { Redirect } from 'react-router-dom'

const Text = ({img, text}) => (
  <span className="flex justify-between items-center pl1">
    <img src={img} alt="radio" className="pr2"/>
    <RadioText>{text}</RadioText>
  </span>
)
const APIurl = `${config.URI}/api/v1/get_domain`

class Form extends Component {
  constructor(props) {
    super(props)

    this.state = {
      companyName: '',
      companySignup: false,
      hasErrors: false,
      userTypeError: false,
      usernameError: null,
      emailError: null,
      passwordError: null,
      rpasswordError: null,
      userType: 'guest',
      url: null
    }
  }

  componentDidMount() {
    const query = parseQuery(this.props.location.search)
    const url = query.url
    if (url) {
      this.setState({companySignup: true, userType: 'admin', url: url})
      const payload = {url}
      return fetch(`${APIurl}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then((temp) => temp.json())
        .then(res => {
          if (res.status && res.status === 'success') {
            this.setState({companyName: res.data.name})
            if (res.data.name) {

            } else {
              alert('無効なURLです')
              window.location = '/signup'
            }
          } else if (res.errors) {
            console.error(res.errors)
          }
        })
        .catch((error) => {
          alert('サーバーとの接続にエラーが発生しました。')
          isSentry(error)
        })

    }
  }

  componentWillUnmount() {
    this.props.authErrors(null)
  }

  handleSubmit = e => {
    this.props.authErrors(null)
    const {userType} = this.state
    e.preventDefault()
    let post = true
    let passwordsMatch = false
    const emailFilter = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let {username, email, password, rpassword} = this.refs
    username = username.getValue()
    email = email.getValue()
    password = password.getValue()
    rpassword = rpassword.getValue()

    if (!username) {
      this.setState({
        usernameError: <FormattedMessage id="login.requiredField"/>,
        hasErrors: true
      })
      post = false
    } else {
      this.setState({usernameError: null})
    }

    if (!email) {
      this.setState({
        emailError: <FormattedMessage id="login.requiredField"/>,
        hasErrors: true
      })
      post = false
    } else if (!emailFilter.test(email)) {
      this.setState({
        emailError: <FormattedMessage id="signUp.emailError"/>,
        hasErrors: true
      })
      post = false
    } else {
      this.setState({emailError: null})
    }

    if (!password) {
      this.setState({
        passwordError: <FormattedMessage id="login.requiredField"/>,
        hasErrors: true
      })
      post = false
    } else if (password.length < 8) {
      this.setState({
        passwordError: <FormattedMessage id="signUp.passwordError.short"/>,
        hasErrors: true
      })
      post = false
    } else if (
      password.search(/\d/) === -1 ||
      password.search(/[a-zA-Z]/) === -1
    ) {
      this.setState({
        passwordError: (
          <FormattedMessage id="signUp.passwordError.alphaNumeric"/>
        ),
        hasErrors: true
      })
      post = false
    } else if (password !== rpassword) {
      this.setState({
        passwordError: <FormattedMessage id="signUp.passwordError.dontMatch"/>,
        rpasswordError: (
          <FormattedMessage id="signUp.passwordError.dontMatch"/>
        ),
        hasErrors: true
      })
      post = false
    } else {
      this.setState({passwordError: null})
      passwordsMatch = true
    }

    if (!rpassword) {
      this.setState({
        rpasswordError: <FormattedMessage id="login.requiredField"/>,
        hasErrors: true
      })
      post = false
    }

    if (passwordsMatch) {
      this.setState({rpasswordError: null})
    }

    if (post) {
      this.setState({hasErrors: false})
      this.props.signupUser(email, password, username, userType, this.state.url)
    }
  }

  handleChange = (e, value) => {
    this.setState({userTypeError: false, userType: value})
  }

  render() {
    if (this.props.loginStatus) {
      if ((this.props.user.plan !== 'free_guest' && this.props.user.plan !== 'guest')) {
        return (
          <Redirect
            to={'/admin'}
          />
        )
      } else {
        return (
          <Redirect
            to={'/'}
          />
        )
      }
    }
    const uncheckedIconColor = this.state.userTypeError ? '#f44336' : '#6B7C93'
    return (
      <form autoComplete="off" onSubmit={this.handleSubmit}>
        {this.props.errors && this.props.errors.length >= 1 ? (
          <div className="tc red">
            {this.props.errors.map((err, index) => (
              <p key={index}>
                {err}
              </p>
            ))}
          </div>
        ) : (
          ''
        )}
        <input style={{display: 'none'}} type="email" name="email"/>
        <input style={{display: 'none'}} type="password" name="password"/>
        <div className="mb2">
          <div className="pt2">
            {this.state.companySignup ? <RadioButton
              style={{
                width: 'auto'
              }}
              uncheckedIcon={
                <UncheckedRadioButton style={{fill: uncheckedIconColor}}/>
              }
              value="admin"
              label={
                <Text
                  img={images.teacherIcon}
                  text={<FormattedMessage id="signUp.admin"/>}
                />
              }
              checked/> : <RadioButton
              style={{
                width: 'auto'
              }}
              uncheckedIcon={
                <UncheckedRadioButton style={{fill: uncheckedIconColor}}/>
              }
              value="guest"
              label={
                <Text
                  img={images.studentIcon}
                  text={<FormattedMessage id="signUp.guest"/>}
                />
              }
              checked/>}
          </div>
        </div>
        <div>
          <div className="mb2">
            {this.state.companySignup && <TextField
              floatingLabelStyle={{
                marginTop: -10
              }}
              ref="companyName"
              style={{height: 65}}
              floatingLabelText={this.state.companyName}
              fullWidth
              disabled
            />}
            <TextField
              floatingLabelStyle={{
                marginTop: -10
              }}
              style={{height: 65}}
              hintText="山田"
              floatingLabelText={<FormattedMessage id="signUp.usernameLabel"/>}
              fullWidth
              ref="username"
              errorText={this.state.usernameError}
            />
            <TextField
              floatingLabelStyle={{
                marginTop: -10
              }}
              style={{height: 65}}
              hintText="yamada@yamada.com"
              floatingLabelText={<FormattedMessage id="login.emailLable"/>}
              fullWidth
              type="email"
              name="email"
              ref="email"
              errorText={this.state.emailError}
            />
            <TextField
              floatingLabelStyle={{
                marginTop: -10
              }}
              style={{height: 65}}
              hintText="********"
              floatingLabelText={<FormattedMessage id="login.passwordLable"/>}
              type="password"
              fullWidth
              name="password"
              autoComplete="off"
              ref="password"
              errorText={this.state.passwordError}
            />
            <TextField
              floatingLabelStyle={{
                marginTop: -10
              }}
              style={{height: 65}}
              hintText="********"
              floatingLabelText={
                <FormattedMessage id="signUp.confirmPasswordLabel"/>
              }
              type="password"
              fullWidth
              ref="rpassword"
              errorText={this.state.rpasswordError}
            />
          </div>
          <RaisedButton
            backgroundColor="#FCCE42"
            label={<FormattedMessage id="signUp.createAccount"/>}
            type="submit"
            fullWidth
            labelStyle={{fontWeight: 'normal'}}
            labelColor="#8B7124"
          />
          <div className="tc">
            <HelpText>
              <FormattedMessage id="signUp.agree"/>
            </HelpText>
            <HelpText>
              <FormattedHTMLMessage id="footerMenu.terms"/>
              <FormattedMessage id="signUp.and"/>
              <FormattedHTMLMessage id="footerMenu.policy"/>
            </HelpText>
          </div>
        </div>
      </form>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/components/SignUpForm/SignUpForm.js